import { combineReducers } from 'redux';

// REDUCERS
import elements from './elementsReducer';
import data from './dataReducer';

export default combineReducers({
  elements,
  data,
});
